"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsrPlatformIsolatePoolSym = void 0;
exports.SsrPlatformIsolatePoolSym = Symbol('SsrPlatformIsolatePoolSym');
//# sourceMappingURL=ssrPlatformIsolatePool.js.map